import React from "react";
import classes from "./attachModal.module.css";
import icons from "../../../../../Data/icons";
const AttachModal = ({ data, closeModal }) => {
  const CloseIcon = icons.close;
  const FileIcon = icons.file;
  const attachments =data?.data.attechments || []

  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تفاصيل الملحقات</h2>
        </div>
        { attachments.map((attach) => (
            <div className={classes.modalBody} key={attach.id}>
              <div class="user-profile">
                <div class="post-about card-body">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="icon">
                 {attach.file.split(".").pop() !== "pdf" ?    <a href={attach.file} target="_blank"><FileIcon /></a>    :
                    <iframe src={attach.file}>

                    </iframe>}
                      </div>
                      <div>
                        <h5 className="mb-1">{attach.name}</h5>
                       
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ) )}
      </div>
    </div>
  );
};

export default AttachModal;
